import { api } from "../utils/api";

export type BookingChangeGroup = {
    "history_id": number,
    "history_date": string,
    "user": string,
    "changes": 
        {
            "field_name": string,
            "old_value": string | number,
            "new_value": string | number
        }[]
}

export const getReservationHistory = async (bookingId: number) => {
    const url = `/api/v1/account-reservation/detail/${bookingId}/history`;

    const response = await api.get<BookingChangeGroup[]>(url);
    return response;
};
